<template>
    <v-text-field
        v-model="innerValue"
        v-bind="safeFieldProps"
        :label="computedLabel"
        :placeholder="props.placeholder"
        variant="outlined"
        :type="props.type"
        :counter="props.counter"
        :prepend-inner-icon="props.prependInnerIcon"
        :append-inner-icon="props.appendInnerIcon"
        rounded
        :readonly="props.readonly"
        class="AQ-text-field"
    >
        <template v-if="$slots.customAppend || $slots['append-inner']" v-slot:append-inner="scope">
            <slot name="customAppend" />
            <slot name="append-inner" v-bind="scope || {}" />
        </template>
        <template
            v-if="$slots.customPrependInner || $slots['prepend-inner']"
            v-slot:prepend-inner="scope"
        >
            <slot name="customPrependInner" />
            <slot name="prepend-inner" v-bind="scope || {}" />
        </template>
    </v-text-field>
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    const props = defineProps<{
        modelValue?: string | number | null | undefined;
        fieldProps?: object;
        label?: string;
        placeholder?: string;
        type?: string;
        counter?: number;
        prependInnerIcon?: string;
        appendInnerIcon?: string;
        required?: boolean;
        readonly?: boolean;
    }>();

    // Default fieldProps to an empty object if not provided
    const safeFieldProps = computed(() => props.fieldProps ?? {});

    const emit = defineEmits<(e: 'update:modelValue', v: string | number | undefined) => void>();
    const innerValue = computed({
        get: () => props.modelValue,
        set: (val: string | number | undefined) => {
            emit('update:modelValue', val);
        },
    });
    const computedLabel = computed(() => {
        if (props.required) {
            return `${props.label} *`;
        }
        return props.label;
    });
</script>
